// extracted by mini-css-extract-plugin
export default {"slide-in-fwd-center":"_package_indexpage__slide-in-fwd-center"};